import { render, staticRenderFns } from "./conversation-builder.vue?vue&type=template&id=851c3954&scoped=true"
import script from "./conversation-builder.ts?vue&type=script&lang=ts&external"
export * from "./conversation-builder.ts?vue&type=script&lang=ts&external"
import style0 from "./conversation-builder.less?vue&type=style&index=0&id=851c3954&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "851c3954",
  null
  
)

export default component.exports